import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AuthOverviewRoute extends Route {
  @service store;
  model() {
    return {
      orders: this.store.peekAll('order'),
      locations: this.store.peekAll('location'),
      stocktakings: this.store.peekAll('stocktaking'),
    };
  }
}
